<template>
    <div class="container-fluid">
        <b-alert v-model="showLoginErrorMessage" variant="danger" class="alert-danger-garden-help">
            Kindly complete your subscription to proceed.
        </b-alert>
        <b-form @submit.prevent="UpdateProfile">
          <b-card no-body class="my-2">
              <b-card-header class="">
                  <b-row class="align-items-center">
                      <b-col md="6"> <b-card-title class="card-title-page-garden-help-default my-1">My Profile
                          </b-card-title></b-col>
                      <b-col md="6">
                          <b-button variant="garden-help-info-light" class="btn-bumblebee btn-garden-help float-end" v-if="type == 'view'" @click="type='edit'">
  <!--                          <font-awesome-icon icon="fa-solid fa-pen" />-->
                            Edit
                          </b-button>
                          <div class="d-flex float-end">
                            <b-button type="submit" variant="garden-help-info-light" class="btn-bumblebee btn-garden-help btn-garden-help-primary mx-2" v-if="type == 'edit' && !updateLoading">
  <!--                            <font-awesome-icon icon="fa-solid fa-pen" />-->
                              Save
                            </b-button>
                            <b-button type="submit" variant="garden-help-info-light" class="btn-bumblebee btn-garden-help btn-garden-help-primary mx-2" :disabled="!!updateLoading" v-if="!!updateLoading">
  <!--                            <font-awesome-icon icon="fa-solid fa-pen" />-->
                              <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                              Save
                            </b-button>
                            <b-button variant="garden-help-info-light" class="btn-bumblebee btn-garden-help" v-if="type == 'edit'" @click="type='view'" :disabled="!!updateLoading">
  <!--                            <font-awesome-icon icon="fa-solid fa-pen" />-->
                              Close
                            </b-button>
                          </div>
                      </b-col>
                  </b-row>

              </b-card-header>
          </b-card>


          <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm">

              <b-card class="profile-details-card-garden-help" no-body>
                  <b-card-header class=""><b-card-title class="card-title-garden-help">
                          Contractor Details
                      </b-card-title></b-card-header>
                  <b-card-body class="p-0">
                      <PersonalInfo :type="type" :name="contractor.name" :first_name="contractor.first_name"
                          :last_name="contractor.last_name" :email="contractor.email" :phone_number="contractor.phone"
                          :address="contractor.address" />
                  </b-card-body>
              </b-card>
              <b-card no-body v-if="is_staff==0">
                    <b-card-header class="">
                        <b-card-title class="card-title-garden-help">
                            Subscription Details
                        </b-card-title>
                    </b-card-header>
                  <b-card-body class="px-2 py-4">
                      <b-row class="mx-0">
                          <b-col class="px-4">
                              <!-- <p class="form-label-garden-help my-2 float-left w-auto">
                                  Connect with
                                  <img src="@/assets/images/stripe.png" width="70px" style="margin-top: -3px" />
                              </p>

                              <b-button v-if="!is_loading_connect" variant="garden-help-primary-light"
                                  class="btn-bumblebee btn-garden-help float-right" @click="clickConnectStripe">
                                  Connect
                              </b-button>
                              <b-button v-else type="button" disabled variant="garden-help-primary"
                                  class="btn-bumblebee btn-garden-help float-right">
                                  <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                                  Loading
                              </b-button> -->

                              <SubscriptionDetailsView />
                          </b-col>
                      </b-row>
                  </b-card-body>
              </b-card>
              <b-card class="profile-details-card-garden-help" no-body
                  v-if="contractor.company_legal_name != null && is_staff == 0">
                  <b-card-header class=""><b-card-title class="card-title-garden-help">
                          Company Details
                      </b-card-title>
                    </b-card-header>
                  <b-card-body class="p-0">
                      <CompanyDetails :type="type" :legal_company_name.sync="contractor.company_legal_name"
                          :company_trading_name.sync="contractor.company_trading_name"
                          :primary_email_address.sync="contractor.primary_email"
                          :company_registration_number.sync="contractor.company_reg_no" :vat_number.sync="contractor.vat_no"
                          :company_description.sync="contractor.company_description" :business_name.sync="contractor.business_name" />

                  </b-card-body>
              </b-card>
              <b-card class="profile-details-card-garden-help" no-body>
                  <b-card-header class=""><b-card-title class="card-title-garden-help">
                          Work details
                      </b-card-title></b-card-header>
                  <b-card-body class="p-0">
                      <WorkInfo :type="type" :experience_level.sync="contractor.experience_level"
                          :service.sync="contractor.services" :services_str="contractor.services_str"
                          :services_id="contractor.services_id" :rate.sync="contractor.rate_type"
                          :rate_amount.sync="contractor.rate_amount" :vat_number="contractor.vat_no"
                          :is_sub_contractor="is_staff" :service_options.sync="service_options" />
                  </b-card-body>
              </b-card>
              <b-card
                  class="profile-details-card-garden-help" no-body>
                  <b-card-header class=""><b-card-title class="card-title-garden-help">
                          Social Media
                      </b-card-title></b-card-header>
                  <b-card-body class="p-0">
                      <SocialMediaInfo :type="type" :linkedin.sync="contractor.linkedin" :facebook.sync="contractor.facebook"
                          :website.sync="contractor.website" />

                  </b-card-body>
              </b-card>

              <b-card class="profile-details-card-garden-help" no-body
                  v-if="type != 'edit'">
<!--                v-if="contractor.media.filter((v) => v.media_type != 'company_image').length > 0 || type != 'edit'">-->
                  <b-card-header class=""><b-card-title class="card-title-garden-help">
                          Uploads </b-card-title></b-card-header>
                  <b-card-body class="p-0 mb-3">
                      <b-row class="mx-auto">
                          <b-col xl="4" lg="3" md="6" v-for="item in contractor.media.filter(
                              (v) => v.media_type != 'company_image')" :key="item.id">
                              <a :href="item.path" target="_blank">
                                  <div class="upload-container-garden-help" v-if="item.media_type == 'company_logo'">Company
                                      logo</div>
                                  <div class="upload-container-garden-help" v-if="item.media_type == 'job_reference'">Job
                                      reference</div>
                              </a>
                          </b-col>
                      </b-row>
                  </b-card-body>
              </b-card>

              <b-card class="profile-details-card-garden-help" no-body v-if="type != 'edit'">
                  <b-card-header class=""><b-card-title class="card-title-garden-help">
                          Previous works </b-card-title></b-card-header>
                  <b-card-body class="">
                      <VueSlickCarousel v-if="contractor.media.filter(
                          (v) => v.media_type == 'company_image'
                      ).length > 0" v-bind="settings" class="slick-slider-garden-help">
                          <div v-for="item in contractor.media.filter(
                              (v) => v.media_type == 'company_image'
                          )" :key="item.id" class="">
                              <div> <img :src="item.path" class="m-auto" />
                              </div>
                          </div>
                      </VueSlickCarousel>
                      <p v-else class="text-center form-label-garden-help">No media found</p>
                  </b-card-body>
              </b-card>
          </b-overlay>
        </b-form>

    </div>
</template>


<script>
import axios from "axios";
import $ from "jquery";
import PersonalInfo from "../profile_details_components/PersonalInfo.vue";
import CompanyDetails from "../profile_details_components/CompanyDetails.vue";
import WorkInfo from "../profile_details_components/WorkInfo.vue";
import SocialMediaInfo from "../profile_details_components/SocialMediaInfo.vue";
import SubscriptionDetailsView from "../profile_details_components/SubscriptionDetailsView.vue";

export default {
    name: "GardenHelpContractorProfile",
    components: { PersonalInfo, CompanyDetails, WorkInfo, SocialMediaInfo, SubscriptionDetailsView },
    data() {
        return {
            updateLoading: false,
            service_options: [],
            type: 'view',
            show_overlay: false,
            client_name: "GARDENHELP",
            user_type: localStorage.getItem('user_type'),
            user_id: null, // logined user
            is_staff: false,

            is_loading_connect: false,

            showLoginErrorMessage: false,

            settings: {
                dots: false,
                infinite: false,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 4,
                swipeToSlide: true,
                responsive: [
                    //col-xl-2 col-lg-3 col-md-3 col-6
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            },

            contractor: null,
            images_list: [
                "https://thumbs.dreamstime.com/b/beautiful-manicured-lawn-summer-garden-border-bright-colourful-flowering-shrubs-trees-32424569.jpg",
                "https://img.freepik.com/premium-photo/multicolored-flower-bed-garden-3d-render-raster-illustration_607202-776.jpg",
                "https://thumbs.dreamstime.com/b/beautiful-manicured-lawn-summer-garden-border-bright-colourful-flowering-shrubs-trees-32424569.jpg",
                "https://img.freepik.com/premium-photo/multicolored-flower-bed-garden-3d-render-raster-illustration_607202-776.jpg",
                "https://thumbs.dreamstime.com/b/beautiful-manicured-lawn-summer-garden-border-bright-colourful-flowering-shrubs-trees-32424569.jpg",
                "https://img.freepik.com/premium-photo/multicolored-flower-bed-garden-3d-render-raster-illustration_607202-776.jpg",
                "https://thumbs.dreamstime.com/b/beautiful-manicured-lawn-summer-garden-border-bright-colourful-flowering-shrubs-trees-32424569.jpg",
                "https://img.freepik.com/premium-photo/multicolored-flower-bed-garden-3d-render-raster-illustration_607202-776.jpg",
                "https://thumbs.dreamstime.com/b/beautiful-manicured-lawn-summer-garden-border-bright-colourful-flowering-shrubs-trees-32424569.jpg",
                "https://img.freepik.com/premium-photo/multicolored-flower-bed-garden-3d-render-raster-illustration_607202-776.jpg",
            ]
        }
    },
    mounted() {
        let user = JSON.parse(window.localStorage.getItem("user"));
        this.user_id = user.id
        this.is_staff = user.is_staff

        this.showLoginErrorMessage = this.$route.query.setup ? true : false

        // this.getFilterData()

        this.getContractorData()

      // Get Services Options
      this.getServicesOptions()
    },
    methods: {
        getContractorData() {
            console.log("in get contractor data", this.user_type, this.user_id)
            this.show_overlay = true

            axios
                .get("/operator/contractor/profile", {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    console.log(response)
                    this.contractor = response.data;

                    let services_str = [], services_id = []

                    for (let i = 0; i < response.data.services.length; i++) {
                        let service = response.data.services[i]
                        services_str.push(service.name)
                        services_id.push(service.id)
                    }

                    this.contractor.services_str = services_str
                    this.contractor.services_id = services_id

                    this.show_overlay = false

                });
        },

        clickConnectStripe() {
            console.log("in click connect stripe", this.user_id)
            this.is_loading_connect = true

            let requestData = {
                "client": this.client_name,
                "model_type": "operator",
                "model_id": this.user_id
            }
            console.log(requestData)
            axios
                .post("/payment/stripe/custom-account/create", requestData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        // Authorization:
                        //     "Bearer " +
                        //     JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response);
                    this.$fire({
                        // title: "Title",
                        text: response.data.message,
                        type: "success",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 3000,
                    }).then((r) => {
                        this.is_loading_connect = false;
                        console.log(response.data.stripe_onboarding_link);
                        // const route = this.$router.resolve(response.data.stripe_onboarding_link );
                        // window.open(route.href, '_blank');
                        window.open(response.data.stripe_onboarding_link , '_blank');
                    });
                })
                .catch((error) => {
                    console.log(error.response);
                    this.is_loading_connect = false;
                    this.$fire({
                        // title: "Title",
                        text: error.response.data.error
                            ? error.response.data.error
                            : error.response.data.message,
                        type: "error",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 3000,
                    }).then((r) => {
                        // console.log(r.value);
                    });
                });
        },
        UpdateProfile(e) {
          this.updateLoading = true
          const authedUser = JSON.parse(window.localStorage.getItem("user"));
          let formData = new FormData(e.target);
          formData.append('operator_id', authedUser.id)
          formData.append('phone', formData.get('telephone'))

          // console.log([...formData.entries()])
          axios
              .post("operator/profile", formData, {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  client: this.client_name,
                  Authorization:
                      "Bearer " +
                      authedUser.access_token,
                },
              }).then(res => {
                this.updateLoading = false
                this.getContractorData()
                this.updateLoading = false
                this.$fire({
                  // title: "Title",
                  text: 'Profile has been updated successfully!',
                  type: "success",
                  timer: 3000,
                  // customClass: {
                  //   container: this.swal_container_class,
                  //   confirmButton: this.swal_confirm_button_class,
                  // },
                })
          })

        },
      getServicesOptions() {
        axios
            .get("/services/list", {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                client: this.client_name,
              },
            })
            .then((response) => {
              console.log('service_options', response.data);
              this.service_options = response.data;
            });
      }

    }
}
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profiles_views/MyProfile.vue